// Single source of truth for attached context blocks, shared between
// chat.js (request payload + source chip) and context_panel.js (panel list).
// Keeping one owner avoids the two modules drifting out of sync.

const blocks = [];
const listeners = new Set();

export function getBlocks() {
    return blocks;
}

export function addBlock(block) {
    blocks.push(block);
    notify();
}

export function removeBlockAt(index) {
    if (index < 0 || index >= blocks.length) return;
    blocks.splice(index, 1);
    notify();
}

export function clearBlocks() {
    if (blocks.length === 0) return;
    blocks.length = 0;
    notify();
}

// Register a callback fired on every change with the current block array.
export function onBlocksChanged(listener) {
    listeners.add(listener);
}

function notify() {
    listeners.forEach(fn => fn(blocks));
}
